import { Typography, CircularProgress, Grid, Box, useTheme, useMediaQuery, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Icon for the accordion
import AssetMediaDisplay from "../components/asset/AssetMediaDisplay";
import ArchivedBanner from "../components/asset/ArchivedBanner";
import AssetIdEditModal from "../components/asset/AssetIdEditModal";
import { useAsset, AssetProvider } from "../context/AssetContext";
import AssetHeader from "../components/asset/AssetHeader";
import AssetSidebar from "../components/asset/AssetSidebar";
import AssetErrors from "../components/asset/AssetErrors";
import EditAssetModal from "../components/asset/EditAssetModal";

const AssetPageContent: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { loading, asset } = useAsset();

  if (loading) {
    return <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />;
  }

  if (!asset) {
    return <Typography variant="h6" sx={{ textAlign: 'center', mt: 4 }}>Asset not found</Typography>;
  }

  const hasArchivedBanner = asset.archived === true;
  const CONTENT_MAX_HEIGHT = `calc(100vh - ${150 + (hasArchivedBanner ? 50 : 0)}px)`;

  return (
    <Box sx={{ 
      backgroundColor: theme.palette.background.default, 
      color: theme.palette.text.primary, 
      p: isMobile ? 1.5 : 3,
      // For mobile, we create a flex container that fills the height
      height: isMobile ? 'calc(100vh - 64px - 24px)' : 'auto', // 64px navbar, 24px padding
      display: 'flex',
      flexDirection: 'column'
    }}>
      {hasArchivedBanner && <ArchivedBanner />}
      <AssetHeader />
      <AssetIdEditModal />
      <EditAssetModal />

      {isMobile ? (
        <Box sx={{ 
          flex: 1, // This makes the box take up all available vertical space
          overflowY: 'auto', // THIS ENABLES SCROLLING
          mt: 2 
        }}>
          <Accordion sx={{mb: 1, backgroundImage: 'none', boxShadow: 'none', border: `1px solid ${theme.palette.divider}`, borderRadius: 1 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Asset Information</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <AssetSidebar />
            </AccordionDetails>
          </Accordion>
          <AssetMediaDisplay />
          <AssetErrors />
        </Box>
      ) : (
        // --- DESKTOP LAYOUT (Unchanged) ---
        // The height and overflow constraints are still here, which is correct for desktop.
        <Grid container sx={{ maxHeight: CONTENT_MAX_HEIGHT, overflow: 'hidden' }}>
          <Grid item xs={12} md={3} sx={{ maxHeight: CONTENT_MAX_HEIGHT, overflowY: "auto" }}>
            <AssetSidebar />
          </Grid>
          <Grid item xs={12} md={9} sx={{ maxHeight: CONTENT_MAX_HEIGHT, overflowY: "auto", p: 3 }}>
            <AssetMediaDisplay />
            <AssetErrors />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

// The parent component remains the same
const AssetPage: React.FC = () => {
  return (
    <AssetProvider>
      <AssetPageContent />
    </AssetProvider>
  );
};

export default AssetPage;
